import React from "react";
import { connect } from "react-redux";
import ReactGA from 'react-ga';

import * as candidateActionCreators from "../actionCreators/candidate";
import * as appActionCreators from "../actionCreators/app";
import * as lookupCodeActionCreators from "../actionCreators/lookupCode";
import * as auditLogActionCreators from "../actionCreators/auditLog";
import * as systemParameterActionCreators from "../actionCreators/systemParameter";
import CandidateTable from "../components/candidate/candidate-table";

import { createPdfForCandidates } from "../js/pdf";
import { downloadFile } from "../js/file";

import { Accordion, AccordionTab } from "primereact/accordion";
import { Checkbox } from "primereact/checkbox";
import { AutoComplete } from "primereact/autocomplete";
import { Fieldset } from "primereact/fieldset";

import {
  ROLE_ADMIN,
  ROLE_GOVERNMENT,
  STATUS_WITHDRAWN,
  STATUS_REJECTED,
  STATUS_REGISTERED
} from "../js/const";

import "../css/home.css";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      genderFilter: null,
      activeSelectedRows: [],
      withdrawSelectedRows: [],
      rejectedSelectedRows: [],
      activeIndex: [0],
      activeFilterCheckboxes: {
        AboriginalFlag: false,
        WithDisabilityFlag: false,
        CulturalBackgroundFlag: false,
        SaGovEmployeeFlag: false,
        BoardExpirenceFlag: false
      },
      filteredSkills: [],
      selectedSkills: [],
      filteredRegions: [],
      selectedRegions: [],
      filteredQualifications: [],
      selectedQualifications: []
    };

    // create references to table so we can acces filtering method
    this.activeCandidatesTable = React.createRef();
    this.withdrawnCandidatesTable = React.createRef();
    this.rejectedCandidatesTable = React.createRef();
  }

  componentDidMount() {
    document.title = "Home - BoardingCall - South Australian Government Boards and Committees";
    this.props
      .setLoading(true)
        .then(() => {
          return Promise.all([
            this.props.getGenders(false),
            this.props.getHomePageText(),
            this.props.getGoogleAnalyticsTrackingCode(),
            this.props.getCandidateDetailsIntroText(),
            this.props.getListOfCandidatesText(),
            this.props.getStateGovtEmployeeLink(),
            this.props.getQualificationsHelpText(),
            this.props.getSkillsExpertiseHelpText(),
            this.props.getContactUsPageHtmlText(),
            this.props.setLoading(false)
          ])
        })
      .catch(error => {
        this.props.handleError(error).then(() => this.props.setLoading(false));
      });

    let isAdmin =
      this.props.auth.roles &&
      this.props.auth.roles.some(role => role === ROLE_ADMIN);
    let isGovernment =
      this.props.auth.roles &&
      this.props.auth.roles.some(role => role === ROLE_GOVERNMENT);
    if (
      this.props.auth.isAuthenticated === true &&
      (isAdmin === true || isGovernment === true)
    ) {
      //is invoked immediately after a component is mounted.
      //Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.
      this.props
        .setLoading(true)
        .then(() => {
          return Promise.all([
            this.props.logUserAction(),
            this.props.getSkills(false),
            this.props.getQualifications(false),
            this.props.getRegions(false),
            this.props.getCandidates(),
          ]);
        })
        .then(() => this.props.setLoading(false))
        .catch(error => {
          this.props
            .handleError(error)
            .then(() => this.props.setLoading(false));
        });
    }
     this.initializeReactGA();
  }

 initializeReactGA() {
    ReactGA.initialize(this.props.systemParameter.googleAnalyticsTrackingCode);
     ReactGA.pageview(window.location.pathname + window.location.hash);
 }

 // goToCandidate = rowData =>
 //   this.props.history.push("/candidate/" + rowData.CandidateId);

  goToCandidate = rowData => window.open("#/candidate/" + rowData.CandidateId);

  updateSelectedRows = (e, selectedRowsPropertyName) => {
     this.setState({ [selectedRowsPropertyName]: e.value });
  };

  updateFilterCheckBox = (e, filterFieldsName, filterName, tableRef) => {
    let currentFilterFields = this.state[filterFieldsName];
    let newFilterFields = {
      ...currentFilterFields,
      [filterName]: e.checked
    };
    let newState = {
      ...this.state,
      [filterFieldsName]: newFilterFields
    };
    this.setState(newState);
   
   //this will reset the page number to first page after filter
    tableRef.current.state.first = 0;

  };

  filterSkills = e => {
    setTimeout(() => {
      let results = this.props.lookupCode.skills.filter(skill => {
        return skill.Description.toLowerCase().startsWith(
          e.query.toLowerCase()
        );
      });

      this.setState({ filteredSkills: results });
    }, 250);
  };

  setSkills = (e,tableRef )=> {
    this.setState({ selectedSkills: e.value });
     //this will reset the page number to first page after filter
    tableRef.current.state.first = 0;
  };

  filterRegions = e => {
    setTimeout(() => {
      let results = this.props.lookupCode.regions.filter(region => {
        return region.Description.toLowerCase().startsWith(
          e.query.toLowerCase()
        );
      });

      this.setState({ filteredRegions: results });
    }, 250);
  };

  setRegions = (e,tableRef )=> {
    this.setState({ selectedRegions: e.value });
     //this will reset the page number to first page after filter
    tableRef.current.state.first = 0;
  };

  filterQualifications = e => {
    setTimeout(() => {
      let results = this.props.lookupCode.qualifications.filter(
        qualification => {
          return qualification.Description.toLowerCase().startsWith(
            e.query.toLowerCase()
          );
        }
      );

      this.setState({ filteredQualifications: results });
    }, 250);
  };

  setQualifications = (e,tableRef) => {
    this.setState({ selectedQualifications: e.value });
     //this will reset the page number to first page after filter
    tableRef.current.state.first = 0;
  };

  // update filter in state
  updateGenderFilter = (e, tableRef, genderFilterName) => {
    let gender = e.value ? e.value.Description : "";
    tableRef.current.filter(gender, "GenderDescription", "equals");
    this.setState({ [genderFilterName]: e.value });
  };

  renderAccordionCandidateTableTab = ({
    header,
    candidates,
    isAdmin,
    isGovernment,
    tableRef,
    selectedRows,
    filterFields,
    genderFilter,
    genders
  }) => {
    let key = header.replace(" ", "");
    return (
      <AccordionTab key={key} header={header}>
        {filterFields && (
          <Fieldset
            legend={
              <span>
                Display candidates with <b>ALL</b> of the following attributes
              </span>
            }
          >
            <div className={"p-grid filter-fields "}>
              <div className={"p-lg-3 p-col-12"} style={{paddingLeft:"12px"}}>
                <Checkbox
                  checked={filterFields.checkboxes.AboriginalFlag || false}
                  onChange={e => {
                    this.updateFilterCheckBox(
                      e,
                      filterFields.propertyName,
                      "AboriginalFlag",
                      tableRef
                    );
                  }}
                />
                <label
                  className={"multiline-label"}
                  style={{ verticalAlign: "top" }}
                >
                  Aboriginal or Torres Strait Islander descent
                </label>
              </div>
              <div className={"p-lg-3 p-col-12"}  style={{paddingLeft:"12px"}}>
                <Checkbox
                  checked={filterFields.checkboxes.WithDisabilityFlag || false}
                  onChange={e => {
                    this.updateFilterCheckBox(
                      e,
                      filterFields.propertyName,
                      "WithDisabilityFlag",
                      tableRef
                    );
                  }}
                />
                <label
                  className={"multiline-label"}
                  style={{ verticalAlign: "top" }}
                >
                  A person with a disability
                </label>
              </div>
              <div className={"p-lg-3 p-col-12"}  style={{paddingLeft:"12px"}}>
                <Checkbox
                  checked={
                    filterFields.checkboxes.CulturalBackgroundFlag || false
                  }
                  onChange={e => {
                    this.updateFilterCheckBox(
                      e,
                      filterFields.propertyName,
                      "CulturalBackgroundFlag",
                      tableRef
                    );
                  }}
                />
                <label
                  className={"multiline-label"}
                  style={{ verticalAlign: "top" }}
                >
                  Culturally or linguistically diverse background
                </label>
              </div>
              <div className={"p-lg-3 p-col-12"}  style={{paddingLeft:"12px"}}>
                <Checkbox
                  checked={filterFields.checkboxes.SaGovEmployeeFlag || false}
                  onChange={e => {
                    this.updateFilterCheckBox(
                      e,
                      filterFields.propertyName,
                      "SaGovEmployeeFlag",
                      tableRef
                    );
                  }}
                />
                <label
                  className={"multiline-label"}
                  style={{ verticalAlign: "top" }}
                >
                  SA Government employee
                </label>
              </div>
              <div className={"p-lg-3 p-col-12"}  style={{paddingLeft:"12px"}}>
                <Checkbox
                  checked={filterFields.checkboxes.BoardExpirenceFlag || false}
                  onChange={e => {
                    this.updateFilterCheckBox(
                      e,
                      filterFields.propertyName,
                      "BoardExpirenceFlag",
                      tableRef
                    );
                  }}
                />
                <label
                  className={"multiline-label"}
                  style={{ verticalAlign: "top" }}
                >
                  Board Experience
                </label>
              </div>
              <div className={"p-lg-9 p-col-12"}  style={{paddingLeft:"12px"}}>
                &nbsp;
                </div>
                <div className="p-col-12 p-lg-3 field-label-container">
                  <label>Region(s)</label>
                </div>
                <div className="p-col-12 p-lg-6 field-element-container">
                  <span className="p-fluid">
                      <AutoComplete
                        dropdown={true} 
                        value={this.state.selectedRegions}
                        suggestions={this.state.filteredRegions}
                        completeMethod={this.filterRegions}
                        minLength={1}
                        field="Description"
                        multiple={true}
                        onChange={e => {this.setRegions( e, tableRef);}}
                        placeholder="Select regions"
                      />
                    </span>
                </div>
              <div className={"p-col-12"} style={{paddingLeft:"12px"}}>
                <span>
                  <b>AND</b> any of the following skills <b>OR</b>{" "}
                  qualifications
                </span>
              </div>
              <div className="p-col-12 field-label-container">
                <label>Skills or Expertise</label>
              </div>
              <div className="p-col-12 field-element-container">
                <span className="p-fluid">
                    <AutoComplete
                      value={this.state.selectedSkills}
                      suggestions={this.state.filteredSkills}
                      completeMethod={this.filterSkills}
                      minLength={1}
                      field="Description"
                      multiple={true}
                      onChange={e => {this.setSkills( e, tableRef);}}
                      placeholder="Start typing to choose from available skills in the drop-down list"
                    />
                  </span>
              </div>
              <div className="p-col-12 field-label-container">
                <label>Qualifications</label>
              </div>
              <div className="p-col-12 field-element-container">
                <span className="p-fluid">
                    <AutoComplete
                     id="qualificationAutocomplete"
                      value={this.state.selectedQualifications}
                      suggestions={this.state.filteredQualifications}
                      completeMethod={this.filterQualifications}
                      minLength={1}
                      field="Description"
                      multiple={true}
                      onChange={e => {this.setQualifications( e, tableRef);}}
                      placeholder="Start typing to choose from available qualifications in the drop-down list"
                    />
                  </span>
              </div>
            </div>
          </Fieldset>
        )}
        <CandidateTable
          candidates={candidates}
          goToCandidate={this.goToCandidate}
          tableRef={tableRef}
          isAdmin={isAdmin}
          selectedRows={selectedRows}
          exportExcel={this.exportExcel}
          exportPdf={this.exportPdf}
          updateSelectedRecords={this.updateSelectedRecords}
          isGovernment={isGovernment}
          genderFilter={genderFilter}
          genders={genders}
        />
      </AccordionTab>
    );
  };

  render() {
    let isAuthenticated = this.props.auth.isAuthenticated;
    let isAdmin =
      this.props.auth.roles &&
      this.props.auth.roles.some(role => role === ROLE_ADMIN);
    let isGovernment =
      this.props.auth.roles &&
      this.props.auth.roles.some(role => role === ROLE_GOVERNMENT);
    let activeCandidates = this.applyFilters(
      this.props.candidate.candidates.filter(
        candidate => candidate.StatusCode === STATUS_REGISTERED
      ),
      this.state.activeFilterCheckboxes
    );
    let withdrawnCandidates = this.props.candidate.candidates.filter(
      candidate => candidate.StatusCode === STATUS_WITHDRAWN
    );
    let rejectedCandidates = this.props.candidate.candidates.filter(
      candidate => candidate.StatusCode === STATUS_REJECTED
    );
    let genders = this.props.lookupCode.genders;

    let activeSelectedRows = {
      propertyName: "activeSelectedRows",
      value: this.state.activeSelectedRows,
      onChange: this.updateSelectedRows
    };

    let withdrawSelectedRows = {
      propertyName: "withdrawSelectedRows",
      value: this.state.withdrawSelectedRows,
      onChange: this.updateSelectedRows
    };

    let rejectedSelectedRows = {
      propertyName: "rejectedSelectedRows",
      value: this.state.rejectedSelectedRows,
      onChange: this.updateSelectedRows
    };

    let activeFilterFields = {
      propertyName: "activeFilterCheckboxes",
      checkboxes: this.state.activeFilterCheckboxes
    };

    let candidateTableTabDefinitions = [
      {
        header: "Active Candidates",
        candidates: activeCandidates,
        tableRef: this.activeCandidatesTable,
        selectedRows: activeSelectedRows,
        filterFields: activeFilterFields
      },
      {
        header: "Withdrawn Candidates",
        candidates: withdrawnCandidates,
        tableRef: this.withdrawnCandidatesTable,
        selectedRows: withdrawSelectedRows
      },
      {
        header: "Rejected Candidates",
        candidates: rejectedCandidates,
        tableRef: this.rejectedCandidatesTable,
        selectedRows: rejectedSelectedRows
      }
    ];

    let genderFilter = {
      filterName: "genderFilter",
      value: this.state.genderFilter,
      onChange: this.updateGenderFilter
    };

    let candidateTableTabs = candidateTableTabDefinitions.map(tab => {
      return this.renderAccordionCandidateTableTab({
        ...tab,
        isAdmin,
        isGovernment,
        genderFilter,
        genders
      });
    });
    return (
      <React.Fragment>
        {isAdmin && <h1>View Candidates as Administrator</h1>}
        {isGovernment && (
          <h1>View Candidates as Government Department/Agency</h1>
        )}
        {isAuthenticated === true && (isGovernment || isAdmin) && (
          <div className="p-col-12 no-padding">
            <p
              dangerouslySetInnerHTML={{
                __html: this.props.systemParameter.listOfCandidatesText
              }}
            />
          </div>
        )}
        {isAuthenticated === true && (isGovernment || isAdmin) && (
          <Accordion
            activeIndex={this.state.activeIndex}
            onTabChange={e => this.setState({ activeIndex: e.index })}
            multiple={true}
          >
            {candidateTableTabs}
          </Accordion>
        )}
        {!isGovernment && !isAdmin && (
          <div
            className={"home-page-text"}
            dangerouslySetInnerHTML={{
              __html: this.props.systemParameter.homePageText
            }}
          />
        )}
      </React.Fragment>
    );
  }

  applyFilters = (candidates, filterFields) => {
    //Filter Candidates by Attributes using a structure enforces AND and OR

    //Filter Candidates into subset based on "And" filters
    if (filterFields.AboriginalFlag) {
      candidates = candidates.filter(
        candidate => candidate.AboriginalFlag === filterFields.AboriginalFlag
      );
    }
   if (filterFields.WithDisabilityFlag) {
      candidates = candidates.filter(
        candidate =>
          candidate.WithDisabilityFlag === filterFields.WithDisabilityFlag
      );
    }
  if (filterFields.CulturalBackgroundFlag) {
      candidates = candidates.filter(
        candidate =>
          candidate.CulturalBackgroundFlag ===
          filterFields.CulturalBackgroundFlag
      );
    }
 if (filterFields.SaGovEmployeeFlag) {
      candidates = candidates.filter(
        candidate =>
          candidate.SaGovEmployeeFlag === filterFields.SaGovEmployeeFlag
      );
    }
    if (filterFields.BoardExpirenceFlag) {
      candidates = candidates.filter(
        candidate =>
          candidate.BoardExpirenceFlag === filterFields.BoardExpirenceFlag
      );
    }
    
    //Postcodes and Regions
    if (this.state.selectedRegions && this.state.selectedRegions.length > 0) {
      candidates = candidates.filter(
        candidate => (
          (candidate.PostCode >= "5000" &&  candidate.PostCode <= "5199" 
            && this.state.selectedRegions.some(selectedRegion => selectedRegion.SystemCode === "1"))
          || (candidate.PostCode >= "5200" &&  candidate.PostCode <= "5299" 
          && this.state.selectedRegions.some(selectedRegion => selectedRegion.SystemCode === "2"))
          || (candidate.PostCode >= "5300" &&  candidate.PostCode <= "5399" 
          && this.state.selectedRegions.some(selectedRegion => selectedRegion.SystemCode === "3"))
          || (candidate.PostCode >= "5400" &&  candidate.PostCode <= "5499" 
          && this.state.selectedRegions.some(selectedRegion => selectedRegion.SystemCode === "4"))
          || (candidate.PostCode >= "5500" &&  candidate.PostCode <= "5599" 
          && this.state.selectedRegions.some(selectedRegion => selectedRegion.SystemCode === "5"))
          || (candidate.PostCode >= "5600" &&  candidate.PostCode <= "5699" 
          && this.state.selectedRegions.some(selectedRegion => selectedRegion.SystemCode === "6"))
          || (candidate.PostCode >= "5700" &&  candidate.PostCode <= "5799" 
          && this.state.selectedRegions.some(selectedRegion => selectedRegion.SystemCode === "7"))
          || (candidate.PostCode >= "5800" &&  candidate.PostCode <= "5999" 
          && this.state.selectedRegions.some(selectedRegion => selectedRegion.SystemCode === "1"))
          || (candidate.PostCode >= "0800" &&  candidate.PostCode <= "0899" 
          && this.state.selectedRegions.some(selectedRegion => selectedRegion.SystemCode === "8"))
        )
      );

    }


    // Skills and Qualification filtering using OR

    if (this.state.selectedSkills && this.state.selectedSkills.length > 0) {
      //Filter by candidates subset by SKills
     let  candidatesFilterBySkill = candidates.filter(candidate => {
        let skills = candidate.SkillLookups
          ? candidate.SkillLookups.$values
          : [];
        return skills.some(skill =>
          this.state.selectedSkills.some(
            selectedSkill => selectedSkill.CodeLovId === skill.CodeLovId
          )
        );
      });
      // we have filtered the candidates by skills
      //check if we need to also filter by qualification as well
              if (
                this.state.selectedQualifications &&
                this.state.selectedQualifications.length > 0
              ) {
                 //Filter by candidates subset by qualification
              let  candidatesFilteredByQualification = candidates.filter(candidate => {
                  let qualifications = candidate.QualificationLookups
                    ? candidate.QualificationLookups.$values
                    : [];
                  return qualifications.some(qualification =>
                    this.state.selectedQualifications.some(
                      selectedQualification =>
                        selectedQualification.CodeLovId === qualification.CodeLovId
                    )
                  );
                });
                  if (candidatesFilteredByQualification) {
                      //If we have filtered candidates by both Skills and qualifications merge the subsets
                      let concatAndDeDuplicateObjects = (p, ...arrs) => [].concat(...arrs).reduce((a, b) => !a.filter(c => b[p] === c[p]).length ? [...a, b] : a, []);
                      candidatesFilterBySkill = concatAndDeDuplicateObjects('$id', candidatesFilterBySkill, candidatesFilteredByQualification);
                  }
              }
           return candidatesFilterBySkill ;        
    }
    else if (
      //only filtered by Qualifications and not skill
      this.state.selectedQualifications &&
      this.state.selectedQualifications.length > 0
    ) {
     let  candidatesFilteredByQualification = candidates.filter(candidate => {
        let qualifications = candidate.QualificationLookups
          ? candidate.QualificationLookups.$values
          : [];
        return qualifications.some(qualification =>
          this.state.selectedQualifications.some(
            selectedQualification =>
              selectedQualification.CodeLovId === qualification.CodeLovId
          )
        );
      });
      return candidatesFilteredByQualification;
    }


    return candidates;

  };

  getSelectedCandidateIds = (tableRef, selectedRows) => {
    // If there is a selection, give priority to that
    if (selectedRows && selectedRows.length > 0) {
      return selectedRows.map(candidate => candidate.CandidateId);
    } else {
      let processedCandidates = tableRef.current.processData();
      return processedCandidates.map(candidate => candidate.CandidateId);
    }
  };

  getSelectedCandidateUniqueIds = (tableRef, selectedRows) => {
    // If there is a selection, give priority to that
    if (selectedRows && selectedRows.length > 0) {
      return selectedRows.map(candidate => candidate.UniqueId);
    } else {
      let processedCandidates = tableRef.current.processData();
      return processedCandidates.map(candidate => candidate.UniqueId);
    }
  };


  exportPdf = (tableRef, selectedRows) => {
    let candidateIds = this.getSelectedCandidateUniqueIds(tableRef, selectedRows);
    let filters = JSON.stringify( {"ActiveFilterCheckboxes" : this.state.activeFilterCheckboxes, 
                                    "selectedSkills" : this.state.selectedSkills,
                                    "selectedQualifications" : this.state.selectedQualifications,
                                    "selectedRegions" : this.state.selectedRegions});

    this.props
      .setLoading(true)
      .then(() => this.props.exportToPdf({"CandidateIds": candidateIds, "Filters": filters }))
      .then(() => this.props.getCandidatesDetails(candidateIds))
      .then(response => {
        let candidates = response.data ? response.data.$values : [];
        createPdfForCandidates(candidates);
      })
      .then(() => this.props.setLoading(false));
  };

  exportExcel = (tableRef, selectedRows) => {
    let candidateIds = this.getSelectedCandidateIds(tableRef, selectedRows);
    let filters = JSON.stringify( {"ActiveFilterCheckboxes" : this.state.activeFilterCheckboxes, 
                                    "selectedSkills" : this.state.selectedSkills,
                                    "selectedQualifications" : this.state.selectedQualifications,
                                    "selectedRegions" : this.state.selectedRegions});
    this.props
      .setLoading(true)
      .then(() => this.props.exportToExcel(candidateIds))
      .then(response => {
        var fileData = new Blob([response.data], {
          type: "application/vnd.ms-excel"
        });

        // get filename from the content disposition header that is set server side
        let contentDisposition = response.headers["content-disposition"];
        let filename = contentDisposition.substring(
          contentDisposition.indexOf("=") + 1
        );
        downloadFile(fileData, filename);

        this.props.setLoading(false);
      })
      .catch(error =>
        this.props.handleError(error).then(() => this.props.setLoading(false))
      );
  };
}

const mapStateToProps = state => {
  let { candidate, auth, lookupCode, systemParameter } = state;
  return { candidate, auth, lookupCode, systemParameter };
};

// this is how to combine actions available
const actionCreators = {
  ...candidateActionCreators,
  ...appActionCreators,
  ...lookupCodeActionCreators,
  ...systemParameterActionCreators,
  ...auditLogActionCreators,
};

export default connect(
  mapStateToProps,
  actionCreators
)(Home);



// WEBPACK FOOTER //
// ./src/container/Home.js